<template>
  <div id="app">
    <transition name="slide-left">
    <router-view/>
  </transition>
  </div>
</template>

<script>
import '@/assets/iconfont/iconfont.css';
import './styles/global.scss';

export default {
  name: 'App',
};
</script>

<style lang="scss">
html {
  height: 100%;
  font-size: 15px;
  font-family: Verdana,Microsoft Yahei,SimSun,Helvetica;
  color: #000;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  height: 100%;
  background-color: #fff;
  user-select: none;
}

#app {
  height: 100%;
}

.page {
  background-color: #f3f3f3;
  height: 100%;
  transition: all .6s cubic-bezier(.55,0,.1,1);
}

.animation {
  transition: opacity .6s cubic-bezier(.55,0,.1,1);
}

.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(50px, 0);
  transform: translate(50px, 0);
}

.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-50px, 0);
  transform: translate(-50px, 0);
}
</style>



// WEBPACK FOOTER //
// App.vue?08b2d649